import React from 'react'
import { strCol } from '@integec/grid-tools/lib/cols'

import { getCompanyUserMapping } from 'api/pgads.js'
import CommonScreen from './CommonScreen'

const MisoCompanyUsers = _ => {
  return (
    <CommonScreen
      title="Company User Mapping"
      header={MisoUsersHeaders}
      retrieveTask={getCompanyUserMapping}
      altBy={d => d.str1}
      autoRetrieve
      sortOptions={MisoUsersHeaders}
      totalWidth={620}
      onInsertEvent={_ => false}
      withoutModify
      withDelete={false}
      allowInsert={false}
    />
  )
}

export default MisoCompanyUsers

const MisoUsersHeaders = [
  strCol({
    ident: 'str1',
    display: 'Company ID',
    isKey: true,
    sortOrder: 'asc',
    width: 200,
  }),
  strCol({
    ident: 'str2',
    display: 'Company Name',
    isKey: true,
    sortOrder: 'asc',
    width: 200,
  }),
  strCol({
    ident: 'str3',
    display: 'Username',
    isKey: true,
    sortOrder: 'asc',
    width: 200,
  }),
]
